export default {
  204: true,
  226: true,
  236: true,
  249: true,
  250: true,
  257: true,
  263: true,
  289: true,
  306: true,
  343: true,
  354: true,
  365: true,
  368: true,
  367: true,
  382: true,
  403: true,
  416: true,
  418: true,
  428: true,
  431: true,
  437: true,
  438: true,
  450: true,
  468: true,
  474: true,
  506: true,
  514: true,
  519: true,
  548: true,
  579: true,
  581: true,
  584: true,
  587: true,
  600: true,
  604: true,
  613: true,
  622: true,
  639: true,
  647: true,
  672: true,
  683: true,
  705: true,
  709: true,
  742: true,
  753: true,
  778: true,
  780: true,
  782: true,
  807: true,
  819: true,
  825: true,
  867: true,
  873: true,
  879: true,
  902: true,
  905: true,
  942: true,
}
